<template>
  <tr class="evaluation-viewer-evidence-item">
    <td>{{ evidenceItem.id }}</td>
    <td>{{ evidenceItem.name }}</td>
    <td class="text-center">{{ evidenceItem.name.split('.').pop() }}</td>
    <td class="text-right">
      <!--<el-button size="small">Visualizar</el-button>-->
      <el-button
        size="small"
        @click="download">
        Descargar
      </el-button>
    </td>
  </tr>
</template>

<script>
/**
   * 'EvaluationViewerEvidenceItem' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'EvaluationViewerEvidenceItem',
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  computed: {
    evidenceItem () {
      return this.item.data ? this.item.data : this.item
    }
  },
  methods: {
    download () {
      document.location = process.env.API_URL + 'download/' + this.evidenceItem.id
    }
  }
}

</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
    .evaluation-viewer-evidence-item {

    }
</style>



// WEBPACK FOOTER //
// src/modules/evaluation-viewer/components/evaluation-viewer-evidence-item.vue